<template>
  <div v-if="canView()" class="h-100">
    <div v-if="loadingCompany || loadingUser" class="h-100 d-flex justify-content-center align-items-center">
      <Loading />
    </div>
    <div v-else-if="company && !company.disabled && company.approved" class="h-100">
      <BNavbar class="header sticky-top d-print-none d-block border-bottom m-0 px-3 py-3" variant="white">
        <div class="row m-0 align-items-center">
          <BushelBtn
            v-if="tab !== 'Menu'"
            :class="`btn-sm  d-none d-sm-inline-block`"
            btn-container-class=""
            variant="primary"
            :ripple="false"
            :outline="tab !== 'Menu'"
            @click="tab = 'Menu'"
          >
            <i class="fas fa-cannabis" />
            View Menu
          </BushelBtn>

          <CompanyChatWindowWithTrigger
            v-if="showProfileChat"
            :class="loggedIn ? 'ml-auto' : ' ml-2'"
            :authorized="true"
            :user="user"
            :company="company"
          />

          <BushelBtn
            v-if="!showProfileChat"
            :class="`btn-sm  d-none d-sm-inline-block ml-2`"
            variant="primary"
            :outline="tab !== 'Contact'"
            :ripple="false"
            @click="tab = 'Contact'"
          >
            <i class="far fa-envelope" />
            Contact Sales
          </BushelBtn>
          <BushelSelect
            v-if="userCanShop && massagedOptions.length > 1 && buyer && buyer.id"
            :value="activeCart"
            label="name"
            no-deselect
            no-padding
            custom-option-names
            class="d-inline-block mx-3"
            :options="massagedOptions"
            hide-main-label
            track-by="name"
          />

          <BushelBtn
            v-if="userCanShop && buyer && buyer.id"
            variant=""
            btn-container-class="p-0"
            :ripple="false"
            class="ml-3"
            flat
            @click="showCart = true"
          >
            <img src="/img/icons/store-cart.svg" alt="Store Cart" height="35px" width="35px" />
            <BBadge v-if="activeCart && activeCart.cart_items_count" class="badge position-absolute" variant="success" style="right: 6px; top: 3px">
              {{ activeCart.cart_items_count }}
            </BBadge>
          </BushelBtn>
          <BushelBtn
            v-if="tab == 'Menu' && !loggedIn"
            :class="`btn-sm ml-auto d-none d-sm-inline-block`"
            btn-container-class=""
            variant="success"
            :ripple="false"
            :outline="false"
            @click="getView() == 'profile' ? (showAuthModal = true) : redirectToProfile()"
          >
            <i class="fas fa-lock" />
            Log In to Order
          </BushelBtn>

          <b-nav-item-dropdown text="Pages" right class="d-sm-none text-primary ml-auto nav">
            <b-dropdown-item @click="cdpModalState = true">
              <i class="fas fa-home text-primary" />
              Company Overview
            </b-dropdown-item>
            <b-dropdown-item @click="tab = 'Menu'">
              <i class="fas fa-cannabis text-primary" />
              View Menu
            </b-dropdown-item>
            <b-dropdown-item @click="tab = 'Contact'">
              <i class="far fa-envelope text-primary" />
              Contact Sales
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <BNavItemDropdown
            v-if="loggedIn && user"
            style="list-style: none"
            :class="`settingsDropdown text-secondary ${userCanShop || showProfileChat ? '' : 'ml-auto'}`"
            dusk="settings-dropdown"
            toggle-class="text-decoration-none"
            no-caret
            right
          >
            <template #button-content>
              <i style="font-size: 1.33333em" class="fa text-secondary fa-cog px-2" />
            </template>
            <b-dropdown-item @click="() => openApexSite()">
              <i class="fas fa-external-link-alt mr-1" />
              Go to ApexTrading
            </b-dropdown-item>
            <BDropdownDivider />
            <b-dropdown-item v-if="loggedIn && hasSwitchableCompanies()" @click="showCompanySelectorModal = true">
              <i class="far fa-building mr-1" />
              Companies
            </b-dropdown-item>
            <BDropdownDivider />
            <b-dropdown-item @click="cdpModalState = true">
              <i class="far fa-paper-plane mr-1" />
              Contact Seller
            </b-dropdown-item>
            <BDropdownDivider />
            <b-dropdown-item @click="onLogout">
              <i class="fas fa-sign-out-alt mr-1" />
              Logout
            </b-dropdown-item>
          </BNavItemDropdown>
        </div>
      </BNavbar>

      <div style="height: calc(100% - 74.6px)">
        <div v-if="loading && !loadingError" class="h-100 row m-0 align-items-center">
          <Loading />
        </div>
        <div v-if="!loading && loadingError" class="h-100 row m-0 align-items-center justify-content-center">
          <div class="alert alert-info small"><b>Connection Issue.</b> Please contact support.</div>
        </div>
        <CompanyDisplay
          v-if="!loading && company && company.id && cdpModalState"
          :company="company"
          :show="cdpModalState"
          @hide="cdpModalState = false"
        />
        <div v-if="tab == 'Menu'" class="h-100">
          <div v-if="!loading && theme && company && products && products.length > 0" class="store h-100">
            <StoreView
              :products="products"
              :categories="productCategories"
              :company="company"
              :theme="theme"
              :user="user"
              :logged-in="loggedIn"
              :cart-items="activeCart && activeCart.cart_items ? activeCart.cart_items : []"
              :cart-options="cartOptions"
              :cart-visible="showCart && buyer && buyer.id ? true : false"
              :cart-minimums="cartMinimums"
              :active-cart="activeCart"
              :loading-cart="loadingCart"
              :order-groups="orderGroups"
              :dispatching-order="dispatchingOrder"
              :invitation-email="''"
              :created-order="createdOrder"
              :buyer="buyer"
              :buyer-uuid="buyerUuid"
              :hide-prices="shouldHidePrices"
              :hide-quantity="shouldHideQuantity"
              :bulk-discounts="bulkDiscounts"
              :hide-shopping-actions="userCanShop ? false : true"
              :showing-contact-sales="showingContactSales"
              @contact-button-clicked="tab = 'Contact'"
              @show-contact-sales="showingContactSales = true"
              @hide-contact-sales="showingContactSales = false"
              @hide-cart="showCart = false"
              @fetch-cart="(data) => fetchCartAction(data)"
              @remove-from-cart="(item) => removeFromCartAction(item)"
              @handle-update-quantity="(item) => handleUpdateQuantityAction(item)"
              @adjust-to-max-quantity-in-cart="(item) => adjustToMaxQuantityInCartAction(item)"
              @add-to-cart="(product) => addToCartAction(product)"
              @create-order="(order) => createOrderAction(order)"
            />
          </div>
          <div
            v-else-if="!loading && (!products || products.length == 0)"
            class="h-100 w-100 row m-0 align-items-center justify-content-center mt-5 pt-5"
          >
            <div class="text-center mt-5 pt-5">
              <h4>This vendor is currently sold out</h4>
              <img src="img/misc/widget-no-item.svg" alt="Check Back" />
            </div>
          </div>
        </div>

        <Contact v-if="tab == 'Contact' && !loading" :company="company" :user="user" class="mt-4" />
      </div>
    </div>
    <div v-else class="border text-center mt-5 mx-auto p-5" style="max-width: 1000px">
      <h3>Hi thanks for your interest. The menu you are trying to access is no longer available.</h3>
      <div v-if="!loggedIn">
        <h5>Don't worry, we have an entire marketplace of wholesale you can shop from. Click below to login or create to your free buyer account.</h5>
        <div class="mt-3">
          <BushelBtn
            :class="`btn-sm ml-auto d-none d-sm-inline-block`"
            btn-container-class=""
            variant="primary"
            :ripple="false"
            outline
            @click="registerRoute()"
          >
            Sign Up
          </BushelBtn>

          <BushelBtn
            :class="`btn-sm ml-2 d-none d-sm-inline-block`"
            btn-container-class=""
            variant="primary"
            :ripple="false"
            outline
            @click="loginRoute()"
          >
            Login
          </BushelBtn>
        </div>
      </div>
      <div v-else>
        <h5>Don't worry, we have an entire marketplace of wholesale you can shop from. Click below to go to the marketplace.</h5>
        <div class="mt-3">
          <BushelBtn
            :class="`btn-sm ml-auto d-none d-sm-inline-block`"
            btn-container-class=""
            variant="primary"
            :ripple="false"
            outline
            @click="openApexSite()"
          >
            Go to ApexTrading
          </BushelBtn>
        </div>
      </div>
    </div>
    <BulkDiscountModal
      v-if="bulkDiscounts"
      :show="isShowingBulkDiscountModal"
      :bulk-discounts="bulkDiscounts"
      @hide="isShowingBulkDiscountModal = false"
    />
    <StoreAuthModal :visible="showAuthModal" @logged-in="onLoggedIn" @hide="showAuthModal = false" />
    <CompanySelector
      v-if="showCompanySelectorModal && loggedIn"
      :visible="showCompanySelectorModal"
      :companies="companies"
      :seller-company="company"
      :user="user"
      :selected-company="user.current_company"
      @hide="showCompanySelectorModal = false"
      @selected="onSelectCompany"
    />
    <CreateOperationModal
      v-if="showCreateOperationsModal"
      :visible="showCreateOperationsModal"
      :current-company="user.current_company"
      @operation-created="onOperationCreated"
    />
    <AlertNoCompany :visible="showAlertNoCompanyModal" :user="user" @hide="showAlertNoCompanyModal = false" />
    <WaitApprovalModal :visible="showWaitApprovalModal" @hide="closeWaitApprovalModal" />
    <WhileWaitingModal :visible="showWhileWaitingModal" @close="closeWhileWaitingModal" />
    <SendLeadModal
      v-if="showSendLeadModal && company"
      :visible="showSendLeadModal"
      :seller-company="company"
      @request-access="onRequestAccess"
      @close="closeSendLeadModal"
    />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import BNavbar from "@/components/base/BNavbar.vue";
import BNavItemDropdown from "@/components/base/BNavItemDropdown.vue";
import BDropdownItem from "@/components/base/BDropdownItem.vue";
import BDropdownDivider from "@/components/base/BDropdownDivider.vue";
import BBadge from "@/components/base/BBadge.vue";
import CompanyDisplay from "@/components/companyDisplay/CompanyDisplay.vue";
import Contact from "./Contact.vue";
import { ColorLuminance, isObjEmpty, navTo } from "@/services/helpers";
import BulkDiscountModal from "@/components/storefront/BulkDiscountModal.vue";
import StoreView from "../pages/storefront/StoreView.vue";
import CompanyChatWindowWithTrigger from "@/components/chat/CompanyChatWindowWithTrigger.vue";
import StoreAuthModal from "@/components/storefront/auth/StoreAuthModal.vue";
import CompanySelector from "@/components/storefront/auth/CompanySelector.vue";
import AlertNoCompany from "@/components/storefront/auth/AlertNoCompanyModal.vue";
import CreateOperationModal from "@/components/storefront/auth/CreateOperationModal.vue";
import WaitApprovalModal from "@/components/storefront/auth/WaitApprovalModal.vue";
import SendLeadModal from "@/components/storefront/auth/SendLeadModal.vue";
import WhileWaitingModal from "@/components/storefront/auth/WhileWaitingModal.vue";
import * as api from "@/services/api";

export default {
  components: {
    CompanyDisplay,
    Contact,
    BDropdownItem,
    BNavbar,
    BNavItemDropdown,
    BDropdownDivider,
    BBadge,
    BulkDiscountModal,
    CompanyChatWindowWithTrigger,
    StoreView,
    StoreAuthModal,
    CompanySelector,
    AlertNoCompany,
    CreateOperationModal,
    WaitApprovalModal,
    SendLeadModal,
    WhileWaitingModal,
  },
  props: {},
  data() {
    return {
      industry: APP_INDUSTRY,
      isShowingBulkDiscountModal: false,
      showingContactSales: false,
      hidePrices: false,
      hideQuantity: false,
      tab: "Menu",
      cdpModalState: false,
      showAuthModal: false,
      showCompanySelectorModal: false,
      showAlertNoCompanyModal: false,
      selectedCompany: null,
      showCart: false,
      products: [],
      company: {},
      view: "profile",
      theme: null,
      productsLoaded: false,
      bulkDiscounts: [],
      loading: true,
      appName: APP_NAME,
      loadingCompany: true,
      loadingError: false,
      loadingUser: false,
      loggedIn: false,
      companies: [],
      companiesLoading: false,
      buyer: null,
      buyersLoading: false,
      isSeller: false,
      buyerUuid: "",
      cartOptions: [],
      activeCartDynamicIndex: null,
      dispatchingOrder: false,
      createdOrder: false,
      cartMinimums: {},
      orderGroups: [],
      hideShoppingActions: true,
      showCreateOperationsModal: false,
      showWaitApprovalModal: false,
      showWhileWaitingModal: false,
      showSendLeadModal: false,
      userCanShop: false,
      loadingCart: false,
      showedAuth: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    productCategories() {
      const map = new Map();
      const result = [{ id: "default", name: "All Products" }];
      this.products.forEach((product) => {
        if (!map.has(product.category_id)) {
          map.set(product.category_id, true);
          result.push({
            id: product.category_id,
            name: product.category_name,
            long_display_name: product.category_long_display_name,
          });
        }
      });
      return result;
    },
    massagedOptions() {
      return this.cartOptions
        .filter((op) => op.fillable == true)
        .map((val) => {
          const data = val;
          if (val.cart_items_count) {
            data.customOptionName = `${val.name} | ${val.cart_items_count}`;
          } else {
            data.customOptionName = val.name;
          }
          return data;
        });
    },
    showProfileChat() {
      if (this.loggedIn && this.user && this.user.current_company_id && this.company && this.user.current_company_id != this.company.id) {
        return true;
      }
      return false;
    },
    shouldHidePrices() {
      if (this.loggedIn && this.user && this.user.current_company && this.userCanShop) {
        return false;
      }

      if (this.theme && this.theme.page_product_layout_product_price_visible) {
        return !this.theme.page_product_layout_product_price_visible;
      }

      return true;
    },
    shouldHideQuantity() {
      if (this.loggedIn && this.user && this.user.current_company && this.userCanShop) {
        return false;
      }

      if (this.theme && this.theme.page_product_layout_product_quantity_visible) {
        return !this.theme.page_product_layout_product_quantity_visible;
      }

      return true;
    },

    activeCart() {
      if (this.activeCartDynamicIndex) {
        return this.cartOptions.find((cart) => cart.dynamicIndex == this.activeCartDynamicIndex);
      }
      return {};
    },
  },
  mounted() {
    this.queryStringPriceQuantityOverride();
    this.fetchStorefrontProducts();
    this.fetchPublicStorefrontCompany();
    this.fetchPublicStorefrontBulkDiscounts();
  },
  methods: {
    ColorLuminance,
    navTo,
    ...mapActions({
      fetchUserNoDispatching: "auth/fetchUserNoDispatching",
      setActiveCompany: "auth/setActiveCompanyNoDispatching",
      logout: "auth/logout",
    }),
    canView() {
      try {
        if (window.self == window.top) {
          return true;
        }

        if (window.self !== window.top && this.getView() === "widget") {
          return true;
        }

        return false;
      } catch (e) {
        return false;
      }
    },
    redirectToProfile() {
      window.open(`/profile/${this.getSlug()}?auth=true`, "_blank").focus();
    },
    openApexSite() {
      window.location.href = "https://app.apextrading.com";
    },
    getSlug() {
      const path = window.location.pathname;
      return path.split("/").pop();
    },
    showAuthFromQuery() {
      if (window.location.search.includes("auth=true") && this.getView() == "profile" && !this.showedAuth) {
        this.showAuthModal = true;
        this.showedAuth = true;
      }
    },
    getView() {
      const path = window.location.pathname;
      const [view] = path.slice(1).split("/");
      if (view.toLowerCase() == "menu-widget") {
        return "widget";
      }

      return "profile";
    },
    loginRoute() {
      window.location.href = "/login";
    },
    registerRoute() {
      window.location.href = "/register";
    },
    contactButtonClicked() {
      this.tab = "Contact";
    },
    hasSwitchableCompanies() {
      if (this.companies.length > 0) {
        return true;
      }

      return false;
    },
    queryStringPriceQuantityOverride() {
      const uri = window.location.search.substring(1);
      const params = new URLSearchParams(uri);
      if (params.get("front_end_override")) {
        this.hideQuantity = true;
        this.hidePrices = true;
      }
    },
    closeWaitApprovalModal() {
      this.showWaitApprovalModal = false;
    },

    closeWhileWaitingModal() {
      this.showWhileWaitingModal = false;
    },

    closeSendLeadModal() {
      this.showSendLeadModal = false;
    },

    onSelectCompany(company) {
      this.showCompanySelectorModal = false;
      this.setCurrentCompany(company);
    },
    onLogout() {
      this.logout();
      this.loggedIn = false;
    },
    onLoggedIn(loggedIn) {
      this.showAuthModal = false;
      this.isLoggedIn(false);
    },
    onRequestAccess() {
      this.sendCompanyLead();
      setTimeout(() => {
        this.showSendLeadModal = false;
      }, 1000);
    },
    setCurrentCompany(company) {
      this.setActiveCompany({
        id: this.user.id,
        current_company_id: company.id,
      }).then(() => {
        // this.fetchUserCompanies();
        this.canShop();
      });
    },
    partialReloadStorefrontAction() {
      this.dispatchingOrder = false;
      this.createdOrder = false;
      this.fetchCartOptions(this.buyerUuid);
      this.fetchStorefrontProducts(this.buyerUuid);
    },
    handleUpdateQuantityAction(data) {
      api.post(`storefront/cart/update-quantity/${this.buyerUuid}`, data).then(
        (response) => {
          if (response.data && response.data.id) {
            this.handleLoadedCart(response.data);
          } else {
            // problem
          }
        },
        (error) => {
          // problem
        },
      );
    },
    removeFromCartAction(data) {
      api.destroy(`storefront/cart/remove/${this.buyerUuid}/${data}`).then(
        (response) => {
          if (response.data && response.data.id) {
            this.handleLoadedCart(response.data);
          } else {
            // problem
          }
        },
        (error) => {
          // problem
        },
      );
    },
    adjustToMaxQuantityInCartAction(data) {
      api.patch(`storefront/cart/adjustToMax/${this.buyerUuid}/${data}`).then(
        (response) => {
          if (response.data && response.data.id) {
            // refetch cart because bulk discounts /shipping are calculated back end and may have changed
            this.handleLoadedCart(response.data);
          } else {
            // problem
          }
        },
        (error) => {
          // problem
        },
      );
    },
    fetchCartOptions(buyerUUID) {
      api.get(`storefront/cartOptions/${buyerUUID}`).then(
        (response) => {
          if (response.data) {
            this.cartOptions = response.data;
            if (!this.activeCartDynamicIndex) {
              if (!this.isTheSeller) {
                let foundSuggested = null;
                let foundOpen = null;
                // let operationCartCount = 0;
                for (let i = 0; i < this.cartOptions.length; i += 1) {
                  if (this.cartOptions[i].suggested_cart) {
                    // sellers suggested cart shown to buyer
                    foundSuggested = this.cartOptions[i];
                  } else if (this.cartOptions[i].buyer_default_cart) {
                    foundOpen = this.cartOptions[i]; // buyers open cart
                  }
                  // else if (this.cartOptions[i].buyer_operation_id) {
                  //   operationCartCount = this.operationCartCount + 1;
                  // }
                }
                if (foundSuggested) {
                  // if the seller suggested a cart and this is that link, go to it.
                  this.changeActiveCart(foundSuggested);
                  this.fetchCartAction(foundSuggested);
                  this.cartVisible = true;
                } else if (foundOpen) {
                  this.changeActiveCart(foundOpen);
                }
              }
              if (!this.activeCartDynamicIndex) {
                // if still not set, default to first
                this.changeActiveCart(response.data[0]);
              }
            }
          }
        },
        (error) => {
          // problem
        },
      );
    },
    fetchCartAction(cart, loading = true) {
      this.changeActiveCart(cart);
      if (cart && cart.cart_id) {
        this.loadingCart = loading;
        api.get(`storefront/cart/${this.buyerUuid}/${cart.cart_id}`).then(
          (response) => {
            if (response.data && response.data.cart_items) {
              this.handleLoadedCart(response.data);
            } else {
              this.cartMinimums = {};
              this.loadingCart = false;
              // this.partialReloadStorefrontAction();
            }
          },
          (error) => {
            this.cartMinimums = {};
            // this.partialReloadStorefrontAction();
          },
        );
      }
    },
    changeActiveCart(cart) {
      this.activeCartDynamicIndex = cart.dynamicIndex;
      this.dispatchingOrder = false;
      this.createdOrder = false;
    },
    handleLoadedCart(data) {
      const newOptions = this.cartOptions.map((cart) => {
        const newCart = { ...cart };
        if (newCart.cart_id == data.id) {
          newCart.cart_items = data.cart_items;
          newCart.cart_items_count = data.cart_items ? data.cart_items.length : 0;
        }
        return newCart;
      });
      this.cartOptions = newOptions;

      this.orderGroups = data.groups;
      this.cartMinimums = {};
      if (!Array.isArray(data.minimums) || !isObjEmpty(data.minimums)) {
        this.cartMinimums = data.minimums;
      }
      this.loadingCart = false;
    },
    addToCartAction(data) {
      const payload = data;
      payload.activeCart = {
        cart_id: this.activeCart.cart_id,
        buyer_operation_id: this.activeCart.buyer_operation_id,
        buyer_location_id: this.activeCart.buyer_location_id,
        dynamicIndex: this.activeCart.dynamicIndex,
      };

      api.patch(`storefront/cart/update/${this.buyerUuid}`, payload).then(
        (response) => {
          if (response.data && response.data.cart_items_count) {
            const newOptions = this.cartOptions.map((cart) => {
              const newCart = { ...cart };
              if (newCart.dynamicIndex == response.data.dynamicIndex) {
                newCart.cart_items = response.data.cart_items;
                newCart.cart_items_count = response.data.cart_items_count;
                newCart.cart_id = response.data.cart_id;
              }
              return newCart;
            });
            this.cartOptions = newOptions;
          } else {
            // problem
          }
        },
        (error) => {
          // problem
        },
      );
    },
    payLaterLink(orderUUID) {
      let partnerName = "";

      if (this.industry == "cannabis") {
        if (this.appEnv == "production") {
          partnerName = "apex";
        } else {
          partnerName = "apexdemo";
        }
      } else if (this.industry == "hemp") {
        if (this.appEnv == "production") {
          partnerName = "bushel";
        } else {
          partnerName = "busheldemo";
        }
      }

      // let buyerCompanyId = order.buyer_company_id;
      // let sellerCompanyId = order.seller_company_id;
      const backendUrl = this.appEnv == "production" ? "https://paylater.app.golendica.com" : "https://paylater.app-idev.golendica.com";
      return `${backendUrl}?partner_name=${partnerName}&partner_invoice_uuid=${orderUUID}`;
    },

    createOrderAction(data) {
      this.dispatchingOrder = true;
      const payload = { ...data };
      payload.cart_id = this.activeCart.cart_id;

      api.post(`receiving-orders/${this.buyerUuid}`, payload).then(
        (response) => {
          this.dispatchingOrder = false;
          if (response.data && response.data.message == "success") {
            this.createdOrder = true;
            this.fetchStorefrontProducts(this.buyerUuid);
            this.cartMinimums = {};
            this.orderGroups = [];

            if (data.payLaterOrder) {
              const payLaterLink = this.payLaterLink(response.data.order.uuid);

              if (payLaterLink) {
                const newWindow = window.open(payLaterLink, "_blank");
                if (!newWindow || newWindow.closed || typeof newWindow.closed == "undefined") {
                  this.showPopupBlockedModal = true;
                  this.lendicaPayLaterUrl = payLaterLink;
                }
              }
            }

            const newOptions = this.cartOptions.map((cart) => {
              const newCart = { ...cart };
              if (newCart.cart_id == payload.cart_id) {
                newCart.cart_items = [];
                newCart.cart_items_count = 0;
              }
              return newCart;
            });
            this.cartOptions = newOptions;
          } else if (response.data && response.data.message == "failure") {
            window.location.reload(true); // lets just do this for now, can improve later when time allows
            // this.cartMinimums = {};
            // if (
            //   !Array.isArray(response.data.cart.minimums)
            //                 || !isObjEmpty(response.data.cart.minimums)
            // ) {
            //   this.cartMinimums = response.data.cart.minimums;
            // }
            // this.loadingCart = false;
          }
        },
        (error) => {
          // this is for that off chance the cart is empty on the back-end.
          if (error.response && error.response.status && error.response.status == 400) {
            this.setSnackbar({ variant: "danger", title: "Unable to place order", message: error.response.data.message });
          }
          this.dispatchingOrder = false;
        },
      );
    },
    fetchPublicStorefrontBulkDiscounts() {
      const slug = this.getSlug();
      api.get(`storefront/public-bulk-discounts/${slug}`).then(
        (response) => {
          // this.productsLoading = false;
          if (response.data && response.data) {
            this.bulkDiscounts = response.data;
          } else {
            // problem
          }
        },
        (error) => {
          // problem
        },
      );
    },
    fetchPublicStorefrontCompany() {
      const slug = this.getSlug();
      api.get(`company/by-slug/${slug}`).then(
        (response) => {
          // this.productsLoading = false;
          if (response.data && response.data.data) {
            this.company = response.data.data;
            this.loadingCompany = false;
            this.isLoggedIn();
          } else {
            this.loadingError = true;
            this.loadingCompany = false;
          }
        },
        (error) => {
          this.loadingError = true;
          this.loadingCompany = false;
        },
      );
    },
    fetchStorefrontProducts() {
      const slug = this.getSlug();
      const params = new URL(window.location).searchParams;
      const theme = params.get("theme");
      let uri = `storefront/public-menu/by-slug/${slug}/${this.getView()}`;
      if (theme) {
        uri += `?theme=${theme}`;
      }
      api.get(uri).then(
        (response) => {
          this.productsLoaded = true;
          this.loading = false;

          if (response.data) {
            this.products = response.data.products;
            this.theme = response.data.theme;
          } else {
            // problem
          }
        },
        (error) => {
          // problem
        },
      );
    },
    fetchUserCompanies() {
      this.companiesLoading = true;
      api.get("/companies").then(
        (response) => {
          this.companiesLoading = false;
          if (response.data && response.data.length > 0) {
            this.companies = response.data;
            /*
          if(this.loggedIn){
            if(this.user.current_company.subscription !== 'buyer'){
              if(this.hasSwitchableCompanies()){
                this.showCompanySelectorModal = true;
              }else{
                this.showAlertNoCompanyModal = true;
              }
            }
          } */
          }
        },
        (error) => {
          this.companiesLoading = false;
        },
      );
    },

    canShop() {
      return api.post(`storefront/shoppable/${this.company.id}`).then((response) => {
        if (response.data && response.data.status) {
          if (response.data.status.toLowerCase() == "success") {
            if (response.data.buyer) {
              this.userCanShop = true;
              this.buyer = response.data.buyer;
              this.buyerUuid = response.data.buyer.uuid;
              this.fetchCartOptions(this.buyer.uuid);
            }
          } else {
            this.userCanShop = false;

            if (response.data.message.toLowerCase() == "no operation") {
              this.showCreateOperationsModal = true;
            } else if (response.data.message.toLowerCase() == "lead pending") {
              this.showWhileWaitingModal = true;
            } else if (response.data.message.toLowerCase() == "company not approved") {
              this.showWhileWaitingModal = true;
            } else if (response.data.message.toLowerCase() == "no buyer relationship") {
              this.showSendLeadModal = true;
            }
          }
        }
      });
    },
    onOperationCreated() {
      this.showCreateOperationsModal = false;
      this.canShop();
      this.sendCompanyLead();
    },
    sendCompanyLead() {
      api
        .post("public-profile-messages", {
          company_id: this.company.id,
          company_name: this.user.current_company.name,
          contact_name: this.user.name,
          email: this.user.email,
          phone: this.user.phone,
          message: "I am interested in becoming a buyer for your company.",
          source: "Buyer StoreFront",
          requesting_company_id: this.user.current_company_id,
        })
        .then(
          (response) => {
            this.canShop();
          },
          (error) => {
            // problem
          },
        );
    },
    isLoggedIn(showLoading = true) {
      this.loadingUser = showLoading;
      this.loggedIn = false;
      this.fetchUserNoDispatching().then(
        () => {
          this.loadingUser = false;
          if (this.user.current_company) {
            this.loggedIn = true;
            this.fetchUserCompanies();
            this.canShop();
          } else {
            this.showAuthFromQuery();
          }
        },
        (error) => {
          this.loadingUser = false;
          this.loggedIn = false;
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>

<style scoped>
.storefront_background {
  /* position: absolute; */
  /* height: 100% - 168px; */
  height: calc(100% - 20px);
  overflow: scroll;
  width: 100vw;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  margin-bottom: 20px;
  /* background-attachment: fixed; */
}
.footer {
  z-index: 3;
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>
